import styled from 'styled-components';

export const ModulesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  flex: 1 1 81vw;
  max-width: 92vw;
`;

export const EmptyContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: var(--app-font);
  font-size: 1.5rem;
  min-height: 50vh;
`;

export default {
  ModulesContainer,
  EmptyContainer,
};
